export default "__VITE_ASSET__DAm7kVge__"